<div class="filter-container" [ngClass]="{ expanded: isExpanded }">
  <div class="filter-content">
    <div class="filter-title">
      <h3 data-translation-key="auction_filter_by">
        {{ "auction.filter_by" | translate }}
      </h3>
      @if (isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
      }
    </div>

    <div class="filter-fields">
      @for (field of fields; track field) {
        <div class="filter-field">
          <div class="field-header">
            <label>{{
              field.label | translationsConvertKey : "horse_info"
            }}</label>
            @if (hasValue(field)) {
              <button
                class="btn-clear-field"
                (click)="clearField(field)"
                data-translation-key="buyer_catalogue_clear"
                >
                {{ "buyer_catalogue.clear" | translate }}
              </button>
            }
          </div>
          <!-- Text Input Field -->
          @if (field.type === 'text') {
            <div class="input-container">
              <input
                type="text"
                class="form-control filter-text-input"
                [value]="field.value || ''"
            [placeholder]="
              ('horse_info.enter' | translate) +
              ' ' +
              (field.label | translationsConvertKey : 'horse_info')
            "
                (input)="onTextFilterChange($event, field)"
                (keydown)="onTextFilterKeydown($event, field)"
                [disabled]="isLoading || disableAllFilters"
                />
              </div>
            }
            <!-- Select/Multiselect Field -->
            @if (field.type !== 'text') {
              <div class="select-container">
                <ng-select
                  [items]="field.options"
                  [multiple]="field.type === 'multiselect'"
                  [searchable]="true"
                  [clearable]="true"
                  bindLabel="label"
                  bindValue="value"
                  [(ngModel)]="field.value"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="onFilterChange($event, field)"
                  (clear)="onClear(field)"
            [placeholder]="
              ('horse_info.select' | translate) +
              ' ' +
              (field.label | translationsConvertKey : 'horse_info')
            "
                  [closeOnSelect]="field.type === 'select'"
                  [hideSelected]="field.type === 'multiselect'"
                  [compareWith]="compareWith"
                  [disabled]="isLoading || field.disabled || disableAllFilters"
            [attr.data-translation-key]="
              'horse_info_select' +
              ' ' +
              (field.label | translationsConvertKey : 'horse_info' : true)
            "
                  >
                  <ng-template ng-option-tmp let-item="item">
                    @if (item.isNotSpecified) {
                      {{ "filters_labels.not_specified" | translate }} ({{
                      item.count
                      }})
                    } @else {
                      {{ item.label | horseFieldTranslate : item.fieldType }} ({{
                      item.count
                      }})
                    }
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    @if (item.isNotSpecified) {
                      {{ "filters_labels.not_specified" | translate }} ({{
                      item.count
                      }})
                    } @else {
                      {{ item.label | horseFieldTranslate : item.fieldType }} ({{
                      item.count
                      }})
                    }
                  </ng-template>
                  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    @for (item of items; track item) {
                      <div class="ng-value">
                        <span class="ng-value-label">
                          @if (item.isNotSpecified) {
                            {{ "filters_labels.not_specified" | translate }} ({{
                            item.count
                            }})
                          } @else {
                            {{ item.label | horseFieldTranslate : item.fieldType }} ({{
                            item.count
                            }})
                          }
                        </span>
                        <span
                          class="ng-value-icon right"
                          (click)="onItemClear(field, item, $event)"
                          aria-hidden="true"
                          >×</span
                          >
                        </div>
                      }
                    </ng-template>
                  </ng-select>
                </div>
              }
            </div>
          }
          <div class="clear-btn-wrapper">
            <button
              (click)="clearAllFilters($event)"
              class="btn-clear"
              [disabled]="activeFilters == 0"
              data-translation-key="buyer_catalogue_clear_filters"
              >
              {{ "buyer_catalogue.clear_filters" | translate }} ({{
              activeFilters
              }})
            </button>
          </div>
        </div>
      </div>
    </div>
